import { BottamImageIcon } from '@/assets/icons'
import React from 'react'

export const BottomImage = () => {
  return (
    <div>
        <BottamImageIcon/>
    </div>
  )
}
